/* tslint:disable */
/* eslint-disable */
/**
 * Lendsafe API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicationRequest
 */
export interface ApplicationRequest {
    /**
     * 
     * @type {number}
     * @memberof ApplicationRequest
     */
    applicationId?: number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationRequest
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationRequest
     */
    repaymentTime?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationRequest
     */
    oldLoanExist?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApplicationRequest
     */
    oldLoan?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    workStatus?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationRequest
     */
    workStatusSince?: Date;
    /**
     * 
     * @type {number}
     * @memberof ApplicationRequest
     */
    income?: number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationRequest
     */
    livingCost?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    loanPurpose?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    employer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    employerPhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    idNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    homeStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    civilStatus?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationRequest
     */
    children?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationRequest
     */
    partnerExist?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    partnerIdNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    partnerEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    partnerPhoneNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationRequest
     */
    partnerChildren?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    partnerEmployer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    partnerEmployerPhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    partnerWorkStatus?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationRequest
     */
    partnerWorkStatusSince?: Date;
    /**
     * 
     * @type {number}
     * @memberof ApplicationRequest
     */
    partnerLivingCost?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    partnerCivilStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    partnerHomeStatus?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationRequest
     */
    partnerIncome?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    originReference?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationRequest
     */
    acceptMail?: boolean;
}

/**
 * Check if a given object implements the ApplicationRequest interface.
 */
export function instanceOfApplicationRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApplicationRequestFromJSON(json: any): ApplicationRequest {
    return ApplicationRequestFromJSONTyped(json, false);
}

export function ApplicationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'applicationId': !exists(json, 'applicationId') ? undefined : json['applicationId'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'repaymentTime': !exists(json, 'repaymentTime') ? undefined : json['repaymentTime'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'oldLoanExist': !exists(json, 'oldLoanExist') ? undefined : json['oldLoanExist'],
        'oldLoan': !exists(json, 'oldLoan') ? undefined : json['oldLoan'],
        'workStatus': !exists(json, 'workStatus') ? undefined : json['workStatus'],
        'workStatusSince': !exists(json, 'workStatusSince') ? undefined : (new Date(json['workStatusSince'])),
        'income': !exists(json, 'income') ? undefined : json['income'],
        'livingCost': !exists(json, 'livingCost') ? undefined : json['livingCost'],
        'loanPurpose': !exists(json, 'loanPurpose') ? undefined : json['loanPurpose'],
        'employer': !exists(json, 'employer') ? undefined : json['employer'],
        'employerPhone': !exists(json, 'employerPhone') ? undefined : json['employerPhone'],
        'idNumber': !exists(json, 'idNumber') ? undefined : json['idNumber'],
        'homeStatus': !exists(json, 'homeStatus') ? undefined : json['homeStatus'],
        'civilStatus': !exists(json, 'civilStatus') ? undefined : json['civilStatus'],
        'children': !exists(json, 'children') ? undefined : json['children'],
        'partnerExist': !exists(json, 'partnerExist') ? undefined : json['partnerExist'],
        'partnerIdNumber': !exists(json, 'partnerIdNumber') ? undefined : json['partnerIdNumber'],
        'partnerEmail': !exists(json, 'partnerEmail') ? undefined : json['partnerEmail'],
        'partnerPhoneNumber': !exists(json, 'partnerPhoneNumber') ? undefined : json['partnerPhoneNumber'],
        'partnerChildren': !exists(json, 'partnerChildren') ? undefined : json['partnerChildren'],
        'partnerEmployer': !exists(json, 'partnerEmployer') ? undefined : json['partnerEmployer'],
        'partnerEmployerPhone': !exists(json, 'partnerEmployerPhone') ? undefined : json['partnerEmployerPhone'],
        'partnerWorkStatus': !exists(json, 'partnerWorkStatus') ? undefined : json['partnerWorkStatus'],
        'partnerWorkStatusSince': !exists(json, 'partnerWorkStatusSince') ? undefined : (new Date(json['partnerWorkStatusSince'])),
        'partnerLivingCost': !exists(json, 'partnerLivingCost') ? undefined : json['partnerLivingCost'],
        'partnerCivilStatus': !exists(json, 'partnerCivilStatus') ? undefined : json['partnerCivilStatus'],
        'partnerHomeStatus': !exists(json, 'partnerHomeStatus') ? undefined : json['partnerHomeStatus'],
        'partnerIncome': !exists(json, 'partnerIncome') ? undefined : json['partnerIncome'],
        'originReference': !exists(json, 'originReference') ? undefined : json['originReference'],
        'acceptMail': !exists(json, 'acceptMail') ? undefined : json['acceptMail'],
    };
}

export function ApplicationRequestToJSON(value?: ApplicationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'applicationId': value.applicationId,
        'amount': value.amount,
        'repaymentTime': value.repaymentTime,
        'email': value.email,
        'phoneNumber': value.phoneNumber,
        'oldLoanExist': value.oldLoanExist,
        'oldLoan': value.oldLoan,
        'workStatus': value.workStatus,
        'workStatusSince': value.workStatusSince === undefined ? undefined : (value.workStatusSince.toISOString()),
        'income': value.income,
        'livingCost': value.livingCost,
        'loanPurpose': value.loanPurpose,
        'employer': value.employer,
        'employerPhone': value.employerPhone,
        'idNumber': value.idNumber,
        'homeStatus': value.homeStatus,
        'civilStatus': value.civilStatus,
        'children': value.children,
        'partnerExist': value.partnerExist,
        'partnerIdNumber': value.partnerIdNumber,
        'partnerEmail': value.partnerEmail,
        'partnerPhoneNumber': value.partnerPhoneNumber,
        'partnerChildren': value.partnerChildren,
        'partnerEmployer': value.partnerEmployer,
        'partnerEmployerPhone': value.partnerEmployerPhone,
        'partnerWorkStatus': value.partnerWorkStatus,
        'partnerWorkStatusSince': value.partnerWorkStatusSince === undefined ? undefined : (value.partnerWorkStatusSince.toISOString()),
        'partnerLivingCost': value.partnerLivingCost,
        'partnerCivilStatus': value.partnerCivilStatus,
        'partnerHomeStatus': value.partnerHomeStatus,
        'partnerIncome': value.partnerIncome,
        'originReference': value.originReference,
        'acceptMail': value.acceptMail,
    };
}

